export default __webpack_public_path__ + "static/media/Ct9.a0ae7312.png";